import { Button } from '@bepure/tarkin';
import * as React from 'react';
import ReactDOM from 'react-dom';




interface Props {
    message: string;
    subMessage: string;
}

const BenefitsCallToAction = (props: Props) => {

    return (
        <div className='benefits-cta'>
            <div className='benefits-cta__message'>
                {props.message}
            </div>
            <div className='benefits-cta__sub-message'>
                {props.subMessage}
            </div>
            <div className='benefits-cta__buttons-container'>
                <Button ariaLabel="shop btn" text={'Shop To Join'} onClick={() => window.location.href = '/store'} />
                <Button ariaLabel="sign in btn" text={'Sign In'}  icon={'person_outline'} onClick={() => window.location.href = '/app/login'}/>
            </div>
        </div>
    )
}

export default function render() {
    const elements = document.getElementsByClassName('benefits-call-to-action-banner');
    Array.prototype.map.call(elements, (element: HTMLElement) => {
        const text = element.dataset.message || '';
        const subText = element.dataset.subMessage || '';

        return ReactDOM.render(
            <BenefitsCallToAction message={text} subMessage={subText}/>,
            element,
        );
    });
}
